import React, { useState } from 'react';
import styled from 'styled-components';
import SalesSidebar from './SalesSidebar';
import SalesTopBar from './SalesTopBar';

const Root = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f1f5f9; /* slate-50 */
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  transition: margin-left 0.3s ease;
  margin-left: ${(p) => (p.$sidebarOpen ? '256px' : '80px')};
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  background: #f1f5f9; /* slate-50 */
  padding: 24px;
`;

export default function SalesLayout({ children, title, currentSection }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <Root>
      <SalesSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} currentSection={currentSection} />
      <Main $sidebarOpen={sidebarOpen}>
        <SalesTopBar title={title} onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <Content>{children}</Content>
      </Main>
    </Root>
  );
}
